import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { ConstantsModule } from './../constants/constants.module';
import { DialogPage } from './../root_classes/dialog-page';

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends DialogPage implements OnInit {

	// Form data.
	passwordForm = new FormGroup({
		userNameControl: new FormControl('', [Validators.required, Validators.pattern(/.+@.+\..+/)]),
	});

	// Extra data;
	public buttonText: string;
	public enableAction: boolean;

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal, modalInstance: NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Send button.
		this.buttonText = "Réinitialiser";
		this.enableAction = true;
	}

	ngOnInit(): void {
	}

	public resetPassword(): void {
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var usernameData = {
			"username": this.passwordForm.controls["userNameControl"].value
		};

		this.put("/secure/reset-password", usernameData,
			(response:any) => {
				if (response["DATA"] == "ERR") {
					// Interception d'une erreur.
					this.modalInstance.close(response["VALUE"]);
				} else {
					this.modalInstance.dismiss(response["DATA"]);
				}
			},
			(err:any) => {
				this.modalInstance.close("SYSTEM");
			}
		);
	}
}
